export default class CloudPaths {
    public static PATIENTS: string = "/patients/";
    public static UPI: string = "/upi/";
    public static IS_EXACT: string = "?exact";
}
